import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'grid',
    flexWrap: 'wrap',
    // justifyContent: 'space-between',
    alignItems: 'center',
    columnGap: 25,
    marginBottom: 20,
    [theme.breakpoints.down('sm')]: {
      marginBottom: 0,
      gridTemplateColumns: '1fr',
      rowGap: 10,
      columnGap: 0
    }
  },

  roleSelectorContainer: {
    width: '25%',
    position: 'relative',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      marginBottom: 12
    }
  },
  searchInput: {
    marginBottom: 12
  },
  clearIconButton: {
    position: 'absolute',
    top: '5%',
    right: 32,
    cursor: 'pointer'
  },
  clearIcon: {
    fontSize: 16
  },
  entitySelectorContainer: {
    width: '46%',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      marginBottom: 12
    }
  },
  resourceTypeSelectorContainer: {
    width: '25%',
    position: 'relative',
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  }
}))

export default useStyles
